import {
    CREATE_HATCH_SUCCESS,
    GET_HATCHES_SUCCESS,
    UPDATE_HATCH_SUCCESS,
    DELETE_HATCH_SUCCESS,
    HATCH_PIN_SUCCESS
} from './constants';

const initialHatchesState = {};
/**
 *
 * @param state
 * @param action
 * @returns {{last: boolean}[]|{}}
 */
const hatchesReducer = ( state = initialHatchesState, action ) => {
    switch ( action.type ) {
        case GET_HATCHES_SUCCESS:
        case DELETE_HATCH_SUCCESS: {
            return {
                ...action.hatches
            };
        }
        case CREATE_HATCH_SUCCESS: {
            const oldHatches = Object.keys( state ).map( i => {
                return  { ...state[ i ], last: false };
            } );
            const newHatches = { ...action.hatch, last: true };
            const newHatchesList = [ ...oldHatches, newHatches ];
            return { ...newHatchesList, };
        }
        case UPDATE_HATCH_SUCCESS: {
            return {
                ...state, ...action.hatch
            };
        }
        case HATCH_PIN_SUCCESS : {
            const oldHatch = Object.keys( state ).map( i => state[ i ] );
            const hatchIndex = oldHatch.indexOf( oldHatch.find( el => el.id === action.hatch.id ) );
            state[ hatchIndex ] = action.hatch;
            return { ...state };
        }
        default:
            return state;
    }
};

export { hatchesReducer as hatches };